import { Bookmark } from '@mui/icons-material';
import { Grid, Paper, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { styles } from '../../styles';

interface FormContainerProps {
  title?: string;
  hasBookmark?: boolean;
  children: ReactNode;
}

const FormContainer = ({ title, children, hasBookmark }: FormContainerProps) => {
  return (
    <Grid container spacing={3} component={Paper} sx={styles.formContainer}>
      {!!title && (
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Typography variant="h6">{title}</Typography>
          {hasBookmark && <Bookmark color="primary" sx={{ height: 30, width: 30 }} />}
        </Grid>
      )}
      {children}
    </Grid>
  );
};

export default FormContainer;
